import { fetchData, setHeaderOptions } from "./apiHelpers";
import { InboundDocumentJob } from "./inbound-document-jobs.type";

const BASE_ROUTE = "/inbound-document-jobs";

export async function getInboundDocumentJobsNeedingReview(): Promise<
  InboundDocumentJob[]
> {
  const request = setHeaderOptions({ method: "GET" });
  return fetchData<InboundDocumentJob[]>(
    `${BASE_ROUTE}/needs-review`,
    request
  );
}

export async function markInboundDocumentJobUserMatch(
  jobId: string,
  payload: {
    patientUserId: string;
    patientId?: string | null;
    subjectUserId?: string | null;
    statusDetail?: string | null;
    metadata?: Record<string, unknown>;
  }
): Promise<InboundDocumentJob> {
  if (!jobId || !payload?.patientUserId) {
    throw new Error("jobId and patientUserId are required to mark a match");
  }

  const options = setHeaderOptions({
    method: "POST",
    body: payload,
  });

  return fetchData<InboundDocumentJob>(
    `${BASE_ROUTE}/${encodeURIComponent(jobId)}/match-patient`,
    options
  );
}
